export const header_data = `<table style="width: 100%;">
<tr>
    <td colspan="2" style="width: 50%;">
        <img :src="company_logo" alt="Company Logo" height="100"/>
    </td>
    <td colspan="2" style="width: 50%; text-align: center;" >
        <span style="font-size: 2rem;color: red;">
            {{doc_heading}}</span>
    </td>
</tr>

<tr class="bold-text">
    <td colspan="4">{{doc_name}}</td>
</tr>

<tr class="bold-text">
    <td colspan="3" style="">{{doc_description}}</td>
    <td colspan="1" style="">Page  of x</td>
</tr>

<tr class="bold-text">
    <td style="" >SOP No:</td>
    <td style="" >{{sop_number}}</td>
    <td style="" >Effective Date</td>
    <td style="" >{{effective_date}}</td>
</tr>

<tr class="bold-text">
    <td style="" >Revision No:</td>
    <td style="" >{{revision_number}}</td>
    <td style="" >Supersedes</td>
    <td style="" >{{supersedes}}</td>
</tr>

<tr class="bold-text">
    <td style="" >Revise By</td>
    <td style="" >{{revise_by_date}}</td>
</tr>
</table>`

